.fadeLeft,
.fadeRight,
.fadeTop,
.fadeBottom {
  position: absolute;
  pointer-events: none;
  z-index: 5;
}

.fadeLeft {
  top: 0;
  left: 0;
  height: 100%;
  width: 40px;
}

.fadeRight {
  top: 0;
  right: 0;
  height: 100%;
  width: 40px;
}

.fadeTop {
  top: 0;
  left: 0;
  width: 100%;
  height: 30px;
  z-index: 10;
}

.fadeBottom {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  z-index: 10;
}

.scrollArrow {
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--mantine-color-white);
  border: 1px solid var(--mantine-color-gray-4);
  border-radius: 50%;
  padding: 4px;
  pointer-events: auto;
  cursor: pointer;
}

.scrollArrow:hover {
  background: var(--mantine-color-gray-2);
}

.scrollArrowRight {
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
}

.scrollArrowLeft {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.zoomContainer {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.zoomedContent {
  display: inline-block;
  transform-origin: top left;
}

.zoomToggle {
  position: absolute;
  top: 8px;
  left: 8px;
  height: fit-content;
  width: fit-content;
  padding: 4px;
  z-index: 10;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background: var(--mantine-color-white);
  border-radius: 6px;
  cursor: pointer;
}

.zoomToggle:hover {
  background: linear-gradient(to top, rgba(0, 0, 0, 0.1), transparent);
  background: var(--mantine-color-white);
}

.scrollArrowTop {
  position: absolute;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  z-index: 10;
  opacity: 0.85;
}

.scrollArrowBottom {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  z-index: 10;
  opacity: 0.85;
}

.scrollArrowBottom {
  bottom: 10px;
}
